import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import content from "@/content/siteContent";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-header-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "border-b border-plz-line/60 bg-plz-deep/80 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="brand-logo-link" className="font-heading text-lg font-extrabold tracking-tight text-plz-cream transition-colors duration-300 hover:text-plz-amber">
          PLZ<span className="mx-[3px] inline-block h-[7px] w-[7px] rounded-full bg-plz-orange" aria-hidden="true" />Company
        </Link>
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {content.nav.map((item) => (
            <a
              key={item.target}
              href={item.target}
              data-testid={`nav-link-${item.target.slice(1)}`}
              className="text-sm font-medium text-plz-slate transition-colors duration-300 hover:text-plz-cream"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="hero-book-consultation-btn"
            data-scroll-to={content.navCta.target}
            className="group hidden items-center gap-2 rounded-full bg-plz-orange px-5 py-2.5 font-heading text-sm font-bold text-plz-cream transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-plz-ember sm:flex"
          >
            {content.navCta.label}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-plz-line/60 text-plz-cream lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="border-t border-plz-line/60 bg-plz-deep/95 backdrop-blur-xl lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4" aria-label="Mobile">
            {content.nav.map((item) => (
              <a
                key={item.target}
                href={item.target}
                data-testid={`mobile-nav-link-${item.target.slice(1)}`}
                onClick={() => setOpen(false)}
                className="rounded-xl px-4 py-3 text-base font-medium text-plz-slate transition-colors hover:bg-plz-surface/50 hover:text-plz-cream"
              >
                {item.label}
              </a>
            ))}
            <button
              data-testid="mobile-book-consultation-btn"
              data-scroll-to={content.navCta.target}
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-plz-orange px-6 py-3 font-heading text-sm font-bold text-plz-cream"
            >
              {content.navCta.label}
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
